import { createApp } from 'vue'
import "./tailwind.css"

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import Home from './views/home/index.vue'

import '@/utils/flexible.js'

// > App 实例
const app = createApp(Home)
app.use(ElementPlus)
app.mount('#app')
